module.exports = __webpack_public_path__ + "oтчет-НТИ-2021.pdf";